module.exports = "<h2>Recurso no encontrado</h2>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/notFound/notFound.component.html
// module id = ../../../../../src/app/helpers/components/notFound/notFound.component.html
// module chunks = main